import { NbMenuItem } from '@nebular/theme';
import { NbAccessChecker } from '@nebular/security';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable()
export class PagesMenu {
  constructor(private accessChecker: NbAccessChecker) {}

  getMenu(): Observable<NbMenuItem[]> {
    const yourBrandMenu: NbMenuItem[] = [
      {
        title: $localize`:@@YourBrand:Your Brand`,
        link: '/pages/CalorieFriend/brand',
        icon: { icon: 'star', pack: 'fas' },
        children: undefined,
      },
    ];

    const patientsMenu: NbMenuItem[] = [
      {
        title: $localize`:@@Patients:Clients`,
        link: '/pages/CalorieFriend/Patients',
        icon: { icon: 'user-friends', pack: 'fas' },
        children: undefined,
      },
    ];

    const workoutPlanGroup: NbMenuItem[] = [
      {
        title: 'Workout',
        expanded: true,
        icon: { icon: 'dumbbell', pack: 'fas' },
        children: [
          {
            title: $localize`:@@WorkoutTemplates:Workout Templates`,
            link: '/pages/CalorieFriend/plans/templates/fitness',
            children: undefined,
          },
          {
            title: $localize`:@@MyExercise:My Exercise`,
            link: '/pages/CalorieFriend/my-exercise',
            children: undefined,
          },
        ],
      },
    ];

    const mealPlanGroup: NbMenuItem[] = [
      {
        title: 'Nutrition',
        expanded: true,
        icon: { icon: 'utensils', pack: 'fas' },
        children: [
          {
            title: $localize`:@@Templates:Meal Plan Templates`,
            link: '/pages/CalorieFriend/plans/templates/meal',
            children: undefined,
          },
          {
            title: $localize`:@@MyFood:My Food`,
            link: '/pages/CalorieFriend/my-food',
            children: undefined,
          },
        ],
      },
    ];

    const billingMenu: NbMenuItem[] = [
      {
        title: $localize`:@@Billing:Billing & Packages`,
        link: '/pages/CalorieFriend/Billing',
        icon: { icon: 'file-invoice-dollar', pack: 'fas' },
        children: undefined,
      },
    ];
    const programTemplateMenu: NbMenuItem[] = [
      {
        title: `Programs`,
        link: '/pages/CalorieFriend/program-template',
        icon: { icon: 'calendar-alt', pack: 'fas' },
        children: undefined,
      },
    ];

    const settingsMenu: NbMenuItem[] = [
      {
        title: `Configurations`,
        link: '/pages/CalorieFriend/settings',
        icon: { icon: 'wrench', pack: 'fas' },
        children: undefined,
      },
    ];

    const tutorialMenu: NbMenuItem[] = [
      {
        title: 'Tutorials',
        url: 'https://www.youtube.com/playlist?list=PLI_IGZ0-EjYg3-oMREJnQ4lN1odqXkd9X',
        icon: { icon: 'youtube', pack: 'fab' },
        target: '_blank',
      },
    ];

    return this.accessChecker
      .isGranted('view', 'users')
      .pipe(
        map(() => [
          ...yourBrandMenu,
          ...patientsMenu,
          ...programTemplateMenu,
          ...workoutPlanGroup,
          ...mealPlanGroup,
          ...billingMenu,
          ...tutorialMenu,
          ...settingsMenu,
        ])
      );
  }
}
